/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import React from 'react'
import Button from 'src/components/ts-components/Button'
import Text from 'src/components/ts-components/Text'
import PaymentErrorIcon from 'src/components/icons/PaymentErrorIcon'

interface PaymentErrorProps {
  title: string
  message: string
  onPrimaryAction: () => void
  buttonLabel: string
}

/**
 * Displays a centered error state for the registration payment flow.
 */
const PaymentError: React.FC<PaymentErrorProps> = ({
  title,
  message,
  onPrimaryAction,
  buttonLabel,
}) => {
  return (
    <div
      css={css`
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 32px 16px;
      `}
    >
      <div
        css={css`
          max-width: 600px;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 24px;
          text-align: center;
        `}
      >
        <PaymentErrorIcon />
        <Text variant='heading1' weight='semiBold' color={colors.NEUTRAL_0}>
          {title}
        </Text>
        <Text
          variant='paragraphLarge'
          weight='regular'
          color={colors.NEUTRAL_0}
        >
          {message}
        </Text>
        <div
          css={css`
            width: 100%;
            display: flex;
            justify-content: center;
          `}
        >
          <Button
            text={buttonLabel}
            onClick={onPrimaryAction}
            variant='secondary'
            style={css`
              flex: 0 0 auto;
              width: auto;
            `}
          />
        </div>
      </div>
    </div>
  )
}

export default PaymentError
